import { DeviceManagementConfigurationPolicy } from '@microsoft/microsoft-graph-types-beta';
import { getIntunePolicyAssignmentsFromSchema } from '../../helper';
import { buildLapsGraphSettingsFromSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/windows-laps/helper';
import {
    DeviceConfigurationWindowsLAPSSchema,
    LAPS_POLICY_TEMPLATE_REFERENCE,
} from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/configuration-policy/windows-laps/model';
import {
    createConfigurationPolicy,
    updateConfigurationPolicy,
} from 'projects/angular-clarity/src/app/stores/client/graph/intune/device-configuration-policies/actions';

export function Remediate(
    _tenant: string,
    data: DeviceManagementConfigurationPolicy[],
    schema: DeviceConfigurationWindowsLAPSSchema,
) {
    const name = schema.contains.properties.name?.const;

    const currentPolicy = data.find((res) => res?.name === name);

    const policy: DeviceManagementConfigurationPolicy = {
        name: schema.contains.properties.name?.const,
        description: schema.contains.properties.description?.const,
        platforms: 'windows10',
        technologies: 'mdm',
        roleScopeTagIds: ['0'],
        settings: buildLapsGraphSettingsFromSchema(schema.contains.properties.settings),
        // Bind the policy to the Endpoint Security "Account Protection — Windows LAPS" template so it
        // surfaces under Endpoint Security > Account Protection and accepts the templated settings above.
        templateReference: {
            templateId: LAPS_POLICY_TEMPLATE_REFERENCE.templateId,
        },
    };

    if (currentPolicy?.id) {
        return updateConfigurationPolicy({
            _tenant,
            id: currentPolicy.id,
            policy,
            assignments: getIntunePolicyAssignmentsFromSchema(schema),
        });
    } else {
        return createConfigurationPolicy({
            _tenant,
            policy,
            assignments: getIntunePolicyAssignmentsFromSchema(schema),
        });
    }
}
